if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        media: this.querySelector('.product__media'),
        gallerySlider: this.querySelector('.gallery-image-slider'),
        thumbSlider: this.querySelector('.thumbnail-slider')
      }

      // Add resize observer to update container height
      const resizeObserver = new ResizeObserver(entries => this.update());
      resizeObserver.observe(this); 
    }

    update() {
      this.elements = {
        media: this.querySelector('.product__media'),
        gallerySlider: this.querySelector('.gallery-image-slider'),
        thumbSlider: this.querySelector('.thumbnail-slider')
      };

      const media = this.elements.media;
      if (!media) return;

      const height = media.offsetHeight;
      if (height <= 0) return; // avoid infinite retries

      if (this.elements.gallerySlider)
        this.elements.gallerySlider.style.height = `${height}px`;

      if (this.elements.thumbSlider)
        this.elements.thumbSlider.style.height = `${height}px`;
    }

  });
}
